export enum VisualizationWindowSize {
    Weekly = 1,
    Monthly = 2,
    Quarterly = 3,
    Custom = 99,
}